<ng-container *ngIf="vm.content | contentExtendedData | async as contentData; else shimmerLoading">
  <ng-container *ngIf="contentData.bookmark as playbackInfo">
    <div class="flex-fill d-flex flex-column hero-container mb-3">
      <div class="underlay-layer" *ngIf="contentData.backgroundImageUrl">
        <img
          osnSharedUseAsPicture
          [src]="contentData.backgroundImageUrl"
          [alt]="vm.content.title.en"
          [imgQuery]="imgQuery"
          [param]="underlayImageParam"
        />
      </div>
      <div class="overlay-layer" *ngIf="contentData.backgroundImageUrl">
        <img osnSharedUseAsPicture [src]="contentData.backgroundImageUrl" [alt]="vm.content.title.en" [imgQuery]="imgQuery" />
      </div>
      <div
        class="placeholder-layer"
        *ngIf="!contentData.backgroundImageUrl"
        [style.backgroundImage]="'url(assets/images/placeholder/heroBannerPlaceholder.png)'"
      ></div>
      <div class="container-fluid flex-fill d-flex content-wrapper">
        <div class="vertical-gradient"></div>
        <div class="row d-flex flex-fill align-items-end">
          <div class="col-sm-17 col-md-15 col-xl-10">
            <ng-container *ngTemplateOutlet="contentTemp"></ng-container>
          </div>
        </div>
      </div>
    </div>

    <ng-template #contentTemp>
      <div class="content-area" [class.small-area]="isMobile$ | async">
        <ng-container
          [ngTemplateOutlet]="imageTitleTemp"
          [ngTemplateOutletContext]="{ titleTreatmentUrl: contentData.titleTreatmentImageUrl }"
        ></ng-container>
        <p class="mb-3 episode episode--lg" *ngIf="!playbackInfo.hasProgress && getLatestEpisode(playbackInfo)">
          {{ getLatestEpisode(playbackInfo) }}
        </p>
        <div *ngIf="vm.ribbon" [class.mb-3]="!playbackInfo.hasProgress || !(isMobile$ | async)">
          <div class="ribbon-container">
            <h5 dir="ltr" class="ribbon-text">{{ vm.ribbon }}</h5>
          </div>
        </div>
        <div class="description-container hide-on-mobile hide-on-tablet mb-3">
          <p class="description">{{ contentData.description | currentLocale }}</p>
        </div>
        <ng-container>
          <div [class.hide-on-mobile]="(isMobile$ | async) && vm.ribbon" [class.details-container]="!playbackInfo.hasProgress">
            <osn-shared-short-details
              class="short-details"
              theme="dark"
              [lengthInSeconds]="playbackInfo.contentLength"
              [numberOfSeasons]="contentData.numberOfSeasons"
              [releaseYear]="contentData.releaseYear"
              [ageRate]="contentData.ageRate"
              [showLength]="vm.content.type === 'movie'"
            >
            </osn-shared-short-details>
            <osn-shared-genre-list
              *ngIf="contentData.genres.length"
              [genres]="contentData.genres"
              class="genre-list"
              (genreClickEvent)="onGenreClick($event)"
            ></osn-shared-genre-list>
          </div>
        </ng-container>
        <ng-container *ngIf="playbackInfo.hasProgress">
          <osn-shared-progress-bar
            class="progress-container"
            theme="dark"
            [showProgressMinutes]="true"
            [lengthInSeconds]="playbackInfo.contentLength"
            [elapsedInSeconds]="playbackInfo.bookmarkTime"
          >
          </osn-shared-progress-bar>
        </ng-container>
        <div class="actions">
          <osn-shared-icon-button
            class="hero-play-button"
            data-testid="DetailsPage.playButton"
            osnPlay
            [showLoadingIndicator]="shouldShowPlayButtonSpinner$ | async"
            [guid]="playbackInfo.guid"
            [movieOrSeriesTitle]="vm.content.title"
            (click)="onHeroItemActionClick(HeroItemActionClickType.PlayClick, playbackInfo.hasProgress)"
            [buttonText]="
              vm.content.type
                | playButtonText: playbackInfo.hasProgress:playbackInfo.seasonNumber:playbackInfo.episodeNumber
                | watchFreeTrial
                | translate
            "
            [iconName]="'play'"
          >
          </osn-shared-icon-button>

          <!-- buttonText and icon is set in the directive in case of My List buttons -->
          <osn-shared-icon-button
            osnMyList
            data-testid="DetailsPage.myList"
            class="my-list-btn"
            [programAvailabilityIdUrl]="vm.content.id"
            [title]="vm.content.title"
            [content]="vm.content"
            [itemGuid]="vm.content.guid"
            (click)="onHeroItemActionClick(HeroItemActionClickType.MyListClick, playbackInfo.hasProgress)"
            [type]="'secondary'"
            [expandable]="true"
          >
          </osn-shared-icon-button>
          <a [routerLink]="contentData.routerLink" style="text-decoration: none">
            <osn-shared-icon-button
              data-testid="DetailsPage.moreInfoButton"
              (click)="onHeroItemActionClick(HeroItemActionClickType.MoreInfoClick, playbackInfo.hasProgress)"
              [buttonText]="!(isMobile$ | async) ? ('Heroban_MoreInfo_Btn' | translate) : undefined"
              [iconName]="'more-info'"
              [type]="'secondary'"
              [expandable]="true"
            >
            </osn-shared-icon-button>
          </a>
        </div>
      </div>
    </ng-template>

    <ng-template #imageTitleTemp let-titleTreatmentUrl="titleTreatmentUrl">
      <img
        osnSharedUseAsPicture
        [imgQuery]="titleImgQuery"
        class="title col-xs-18 col-sm-7 pb-3 pl-0 pr-0"
        *ngIf="contentData.titleTreatmentImageUrl"
        [src]="contentData.titleTreatmentImageUrl"
        [alt]="vm.content.title"
      />
      <h1 *ngIf="!contentData.titleTreatmentImageUrl">{{ vm.content.title }}</h1>
    </ng-template>
  </ng-container>
</ng-container>
<ng-template #shimmerLoading>
  <osn-shared-shimmer-loading [useDynamicFullSize]="true"></osn-shared-shimmer-loading>
</ng-template>
